"use strict";

jQuery.fn.getDx = function(){
    var $page = $(this).closest(".book-page");
    if (!$page.length){
        $page = $(Fotobook.book.book).find(".book-page:not(.flyleaf-page)");
    }
    return parseFloat($page.attr("data-dx"));
};